<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col cols="12" md="6">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="text-color"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields.textColor"
                @change="handleChangeTextColor"
              />
              <v-text-field v-model="fields.textColor" label="Text Color" :hide-details="true" />
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="bg"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['background-section'].color"
                @change="handleChangeBackgroundColor"
              />
              <v-text-field
                v-model="fields['background-section'].color"
                label="Background Color"
                :hide-details="true"
              />
            </div>
          </v-col>
        </v-row>

        <div class="mb-6 mt-6">
          <label class="label-input">Padding</label>
          <div class="group-item">
            <v-row>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.top" label="Top Padding" />
              </v-col>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Background Image</label>
          <div class="group-item">
            <!-- <v-text-field v-model="fields['background-section'].image" label="Image URL" /> -->
            <UploadImage
              @callback="handleUploadBackgroundImage"
              :image="{ imageSrc: fields['background-section'].image }"
              :height="`200`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveBackgroundImage"
            />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Container content</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields['container-content'].showStyle" label="Show style" />
              </v-col>
              <v-col cols="12" md="8">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['container-content'].background"
                    @change="e => (fields['container-content'].background = e.target.value)"
                  />
                  <v-text-field v-model="fields['container-content'].background" label="Container background" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Title Card</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.titleCard" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Table Settings</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="border-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.table.borderColor"
                    @change="e => (fields.table.borderColor = e.target.value)"
                  />
                  <v-text-field v-model="fields.table.borderColor" label="Border Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.table.borderWeight"
                  label="Border Weight"
                  hint="e.g. 1px"
                  persistent-hint
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields.table.colBorder" label="Column Border" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields.table.rowBorder" label="Row Border" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields.table.borderFull" label="Border Full" />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Table HTML</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.table.html" :config="editorConfig" />
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';

export default {
  name: 'TPLASectionEditor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'TPLA Section',
        enableAnchor: false,
        textColor: '#000000',
        padding: { top: true, bottom: true },
        'background-section': { color: '#ffffff', image: '' },
        'container-content': { showStyle: false, background: '#ffffff' },
        titleCard: '',
        table: {
          borderColor: '#F35C5C',
          borderWeight: '1px',
          colBorder: true,
          rowBorder: true,
          borderFull: true,
          html: '<table></table>',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleUploadBackgroundImage(obj) {
      this.fields['background-section'].image = obj.imageSrc;
    },
    handleRemoveBackgroundImage() {
      this.fields['background-section'].image = '';
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionTpla(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeTextColor(event) {
      this.fields.textColor = event.target.value;
    },
    handleChangeBackgroundColor(event) {
      this.fields['background-section'].color = event.target.value;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
::v-deep .ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
